import * as React from 'react';
import styled, { css } from 'styled-components';
import { useMemo } from 'react';

import { Select } from 'components/common';
import useSelectedDataLake from 'data-lake/hooks/useSelectedDataLake';
import usePluginEntities from 'hooks/usePluginEntities';
import useActiveDataLakes from 'data-lake/preview/hooks/useActiveDataLakes';
import { INTERNAL_DATA_LAKE_TYPE } from 'data-lake/Constants';

const StyledSelect = styled(Select)`
  min-width: 280px;
`;

const OptionContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
  `,
);

const OptionIcon = styled.div`
  display: flex;
  align-items: center;
`;

const Option = ({ label, value }: { label: string; value: string }) => {
  const dataLakePlugins = usePluginEntities('dataLakeStorageTypes');
  const { data: dataLakes } = useActiveDataLakes();
  const dataLake = dataLakes.find(({ id }) => id === value);
  const dataLakePlugin = dataLakePlugins.find(({ storageType }) => storageType === dataLake.storageType);
  const Icon = dataLakePlugin.icon;

  return (
    <OptionContainer>
      <OptionIcon>
        <Icon />
      </OptionIcon>
      {dataLake.type === INTERNAL_DATA_LAKE_TYPE ? 'Internal' : 'External'} — {label}
    </OptionContainer>
  );
};

const DataLakeTypeSelect = () => {
  const { data: dataLakes } = useActiveDataLakes();
  const { selectDataLake, selectedDataLake } = useSelectedDataLake();
  const dataLakeOptions = useMemo(() => dataLakes.map(({ id, title }) => ({ label: title, value: id })), [dataLakes]);
  const selectOption = (dataLakeId: string) => {
    selectDataLake(dataLakeId);
  };

  return (
    <StyledSelect
      id="dataLakeType"
      name="dataLakeType"
      placeholder="Select Data Lake Type"
      clearable={false}
      valueRenderer={Option}
      optionRenderer={Option}
      options={dataLakeOptions}
      onChange={selectOption}
      value={selectedDataLake.id}
    />
  );
};

export default DataLakeTypeSelect;
